import React, { Component } from 'react';

/* 개발담당:양유빈
 * 화면기능:플랫폼 메인 페이지
 * 세부설명:
*/

export class StoreMsgDtl extends Component {
    static displayName = StoreMsgDtl.name;

    constructor(props) {
        super(props);
        this.state = {
        };
    }
    //초기화
    componentDidMount() {
    }
    componentWillUnmount() {
    } 

    render() {
        return (
            <div>
                공지사항 상세
            </div>
        );
    }
}
